import { UIUtilsEjsVariables } from './UIUtilsEjsVariables.ts';
import { ClientUserState } from './ClientUserState.ts';
import { UIAjaxWrapper } from './network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from './network/UIAPIEndpoints.ts';
import { logError } from './ui_utils/Utils.ts';
export class HelplyLoader {
    static init() {
        var _ClientUserState_userState;
        if (!window.useHelply) return;
        if (!this.initialized) {
            this.loadIfReady();
            return;
        }
        if (!this.isUserIdentified && ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn)) void this.identifyUser();
    }
    static initForFaqPage() {
        if (this.initialized) {
            var _ClientUserState_userState;
            this.show();
            if (!this.isUserIdentified && ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn)) void this.identifyUser();
            return;
        }
        this.loadIfReady();
    }
    static show() {
        var _this_container;
        (_this_container = this.container) === null || _this_container === void 0 ? void 0 : _this_container.classList.remove('hidden');
    }
    static hide() {
        var _this_container;
        (_this_container = this.container) === null || _this_container === void 0 ? void 0 : _this_container.classList.add('hidden');
    }
    static loadIfReady() {
        if (this.initialized) return;
        if (!UIUtilsEjsVariables.helplyWidgetId) return;
        this.initialized = true;
        this.loadWidget();
    }
    static loadWidget() {
        const script = document.createElement('script');
        script.async = true;
        script.setAttribute('data-agent', UIUtilsEjsVariables.helplyWidgetId);
        script.src = 'https://cdn.helply.com/helply-agent.js';
        document.head.appendChild(script);
        window.addEventListener('helplyAgentLoaded', ()=>{
            var _ClientUserState_userState;
            this.container = document.getElementById('helply-agent-root-container');
            this.injectSafeAreaStyles();
            if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn) void this.identifyUser();
        });
    }
    static injectSafeAreaStyles() {
        var _this_container;
        if (!((_this_container = this.container) === null || _this_container === void 0 ? void 0 : _this_container.shadowRoot)) return;
        const style = document.createElement('style');
        const minTopOffset = 60;
        const offset = `max(env(safe-area-inset-top, ${minTopOffset}px), ${minTopOffset}px)`;
        style.textContent = `
            ${this.BODY_SELECTOR} { top: ${offset} !important; height: calc(100% - ${offset}) !important; }
            [part="helply-agent-trigger"] { background-color: #ffffff !important; color: #167FDE !important; }
        `;
        this.container.shadowRoot.appendChild(style);
    }
    static async identifyUser() {
        try {
            var _response_json, _window_helplyAgentWidget, _response_json_user_metadata, _response_json_user_metadata1, _window_helplyAgentWidget1;
            const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiHelplyToken(), undefined, undefined, false);
            if ((response === null || response === void 0 ? void 0 : (_response_json = response.json) === null || _response_json === void 0 ? void 0 : _response_json.token) == undefined) return;
            await ((_window_helplyAgentWidget = window.helplyAgentWidget) === null || _window_helplyAgentWidget === void 0 ? void 0 : _window_helplyAgentWidget.identify({
                token: response.json.token,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                user_metadata: response.json.user_metadata
            }));
            this.isUserIdentified = true;
            (_window_helplyAgentWidget1 = window.helplyAgentWidget) === null || _window_helplyAgentWidget1 === void 0 ? void 0 : _window_helplyAgentWidget1.setEscalationForm({
                name: (_response_json_user_metadata = response.json.user_metadata) === null || _response_json_user_metadata === void 0 ? void 0 : _response_json_user_metadata.username,
                email: (_response_json_user_metadata1 = response.json.user_metadata) === null || _response_json_user_metadata1 === void 0 ? void 0 : _response_json_user_metadata1.email
            });
        } catch (error) {
            logError('HelplyLoader', [
                'Failed to identify user with Helply',
                error
            ]);
        }
    }
}
HelplyLoader.BODY_SELECTOR = '[part="helply-agent-body"]';
HelplyLoader.initialized = false;
HelplyLoader.isUserIdentified = false;
HelplyLoader.container = null;
